import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Container from 'common/Container';
import {
  Contact,
  Process,
  Reviews,
  WhatWeDo,
} from './components';

const PortfolioMichigan = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Container>
        <WhatWeDo />
      </Container>
      <Container>
        <Process themeMode={themeMode} />
      </Container>
      <Container
        sx={{
          backgroundImage:
            'url("https://assets.maccarianagency.com/backgrounds/img1.jpg")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
        borderRadius={isSm ? 4 : 0}
      >
        <Reviews />
      </Container>
      <Container>
        <Contact />
      </Container>
    </Box>
  );
};

PortfolioMichigan.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default PortfolioMichigan;
